import React from 'react';

import { FormattedMessage } from 'react-intl';

import { EditableFulfillmentPlanDate } from '../fulfillment-plan-dates/editable-fulfillment-plan-date';
import { ShipmentDetailsField } from '../field';
import messages from '../messages';
import { updateFulfillmentPlansShipBy } from '../../../../../../fulfillment-plans/fulfillment-plans.api';
import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlanProperty } from '../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useHasFulfillmentPlanRestriction } from '../../../restrictions-context';
import { UiRestrictions } from '../../../../../../enums/component-states';

const ShipByDateFieldId = 'ship-by-date';

export const ShipByDate = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const { shipByDate } = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'fulfillmentPlanDates');

  const isRestricted = useHasFulfillmentPlanRestriction(UiRestrictions.ShipByDate);

  return (
    <ShipmentDetailsField label={<FormattedMessage {...messages.shipByDate} />} labelFor={ShipByDateFieldId}>
      <EditableFulfillmentPlanDate
        allowPastDates
        apiCall={updateFulfillmentPlansShipBy}
        dateValueUtc={shipByDate}
        disabled={isRestricted}
        fulfillmentPlanId={fulfillmentPlanId}
        id={ShipByDateFieldId}
      />
    </ShipmentDetailsField>
  );
};
